import { ProductType } from 'cart-model';
import { appendExternalLeadId, useRouter } from 'common-react';
import { Fund, Identified } from 'funds-model';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { Dispatch } from 'redux';
import ApiState from '../../../model/ApiState';
import FundFilter from '../../../model/FundFilter';
import ProcessType from '../../../model/ProcessType';
import ProductWizardState from '../../../model/ProductWizardState';
import { productWizardActions } from '../../../model/store';
import Screen from '../Screen';
import { initCartFromParameters } from './cartInitialization';

function initProductType(searchParams: URLSearchParams, dispatch: Dispatch<any>): Screen {
  const product = searchParams.get('product');
  let startScreen = Screen.SAVE_OR_INVEST;
  // @ts-ignore
  if (Object.values(ProductType).includes(product)) {
    dispatch(productWizardActions.setProductType(product as ProductType));
    startScreen = Screen.SELECT_PATH;
    if (product === ProductType.ike || product === ProductType.ikze) {
      dispatch(productWizardActions.setIsPensionProcess(true))
    }
  }
  return startScreen;
}

function getStartScreenFromParameters(searchParams: URLSearchParams, apiState: ApiState, dispatch: Dispatch<any>): Screen {
  if (initCartFromParameters(searchParams, apiState.funds, apiState.blockedFundIdns, dispatch)) {
    return Screen.SET_AMOUNTS_PER_FUND;
  }
  return initProductType(searchParams, dispatch);
}

function initProcessType(searchParams: URLSearchParams, dispatch: Dispatch<any>): void {
  const process = searchParams.get('process');
  // @ts-ignore
  if (Object.values(ProcessType).includes(process)) {
    dispatch(productWizardActions.setProcessType(process as ProcessType));
  }
}

function initLeadParam(searchParams: URLSearchParams): void {
  const leadParam = searchParams.get('_lid');
  leadParam && appendExternalLeadId(leadParam);
}

function paramStringToFunds(paramString: string | null, funds: Fund[]): Fund[] {
  return (paramString || '').split(',')
      .map(param => param ? funds.find(fund => fund.identifier === param) : undefined)
      .filter(fund => fund) as Fund[];
}

function paramStringToValues<T extends Identified>(paramString: string | null, apiValues: T[]): T[] {
  return (paramString || '').split(',')
      .map(param => paramStringToValue(param, apiValues))
      .filter(fundType => fundType) as T[];
}

function paramStringToValue<T extends Identified>(paramString: string | null, apiValues: T[]): T | undefined {
  return paramString ? apiValues.find(apiValue => apiValue.id === parseInt(paramString)) : undefined;
}

function initInitialFilter(searchParams: URLSearchParams, dispatch: Dispatch<any>, apiState: ApiState) {
  const fundTypes = paramStringToValues(searchParams.get('fundTypes'), apiState.fundTypes);
  const risks = paramStringToValues(searchParams.get('risks'), apiState.risks);
  const horizon = paramStringToValue(searchParams.get('horizon'), apiState.horizons);
  const umbrellas = paramStringToValues(searchParams.get('umbrellas'), apiState.umbrellas);
  const term = searchParams.get('term') || '';
  const funds = paramStringToFunds(searchParams.get('funds'), apiState.funds);

  dispatch(productWizardActions.setInitialFilter({
    fundTypes,
    risks,
    horizon,
    umbrellas,
    term,
    funds,
  } as FundFilter));
}

const ProductWizardInit: FunctionComponent<{
}> = () => {

  const { match, location } = useRouter();
  const dispatch = useDispatch();
  const apiState = useSelector((state: ProductWizardState) => state.apiState);
  const [url] = useTranslation('url');

  const searchParams = new URLSearchParams(location.search);

  const startScreen = getStartScreenFromParameters(searchParams, apiState, dispatch);
  initProcessType(searchParams, dispatch);
  initInitialFilter(searchParams, dispatch, apiState);
  initLeadParam(searchParams);

  return (
    <Redirect to={`${match.path}/${url(startScreen.code)}`}/>
  );
};

export default ProductWizardInit;
